<div class="loading-overlay">
  <fa-icon
    [icon]="['fas', 'spinner']"
    animation="spin-pulse"
    size="2x"
  ></fa-icon>
  <p class="text mb-0">{{ loaderText }}</p>
</div>
